import { ScrollToParamTypes } from './utils.types';

const scrollTo = ({ target, offsetY = 0, duration = 2 }: ScrollToParamTypes) => {
  return () => {
    if (typeof window === 'undefined' || !window.gsap) return;

    // plugin might exist globally but not be registered yet
    if (!window.gsap.plugins?.scrollTo && window.ScrollToPlugin) {
      window.gsap.registerPlugin(window.ScrollToPlugin);
    }

    window.gsap.to(window, {
      duration,
      scrollTo: { y: `[data-id='${target.slice(1)}']`, offsetY },
      ease: 'power2.out',
    });
  };
};

export default scrollTo;
